module.exports = __webpack_public_path__ + "img/BOWTIE 1 BW.fa06665.svg";